<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Package Risk</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Package Risk</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Package Risk</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click.native="toPkgItem" v-if="!newMode">
            Package Item
            <v-icon right dark>mdi-view-list</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode">
                <v-text-field
                  v-model="mainForm.riskNo"
                  :label="labels.riskNo"
                  :error-messages="errors.collect('riskNo')"
                  data-vv-name="riskNo"
                  :data-vv-as="labels.riskNo"
                  v-validate="'required|numeric|mask_min_value:1|max:10'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.riskNo }}</v-subheader>
                <div class="queryValue">{{ mainForm.riskNo }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="defBusCls"
                  v-model="mainForm.defBusCls"
                  :label="labels.defBusCls"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('defBusCls')"
                  data-vv-name="defBusCls"
                  :data-vv-as="labels.defBusCls"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="defTariff"
                  v-model="mainForm.defTariff"
                  :label="labels.defTariff"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('defTariff')"
                  data-vv-name="defTariff"
                  :data-vv-as="labels.defTariff"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="defStdRiskTxtRef"
                  v-model="mainForm.defStdRiskTxtRef"
                  :label="labels.defStdRiskTxtRef"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('defStdRiskTxtRef')"
                  data-vv-name="defStdRiskTxtRef"
                  :data-vv-as="labels.defStdRiskTxtRef"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="mainForm.perMaxItemNo"
                  :label="labels.perMaxItemNo"
                  :error-messages="errors.collect('perMaxItemNo')"
                  data-vv-name="perMaxItemNo"
                  :data-vv-as="labels.perMaxItemNo"
                  v-validate="'required|numeric|max:10'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="mainForm.perMaxBeneNo"
                  :label="labels.perMaxBeneNo"
                  :error-messages="errors.collect('perMaxBeneNo')"
                  data-vv-name="perMaxBeneNo"
                  :data-vv-as="labels.perMaxBeneNo"
                  v-validate="'required|numeric|max:10'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="defClse"
                  v-model="mainForm.defClse1"
                  :label="labels.defClse1"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('defClse1')"
                  data-vv-name="defClse1"
                  :data-vv-as="labels.defClse1"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="defClse"
                  v-model="mainForm.defClse2"
                  :label="labels.defClse2"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('defClse2')"
                  data-vv-name="defClse2"
                  :data-vv-as="labels.defClse2"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="defClse"
                  v-model="mainForm.defClse3"
                  :label="labels.defClse3"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('defClse3')"
                  data-vv-name="defClse3"
                  :data-vv-as="labels.defClse3"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="defClse"
                  v-model="mainForm.defClse4"
                  :label="labels.defClse4"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('defClse4')"
                  data-vv-name="defClse4"
                  :data-vv-as="labels.defClse4"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :items="defClse"
                  v-model="mainForm.defClse5"
                  :label="labels.defClse5"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('defClse5')"
                  data-vv-name="defClse5"
                  :data-vv-as="labels.defClse5"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-checkbox
                  :label="labels.allowClmBefCvr"
                  v-model="mainForm.allowClmBefCvr"
                  :error-messages="errors.collect('allowClmBefCvr')"
                  data-vv-name="allowClmBefCvr"
                  :data-vv-as="labels.allowClmBefCvr"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode"></v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-checkbox
                  :label="labels.inclRiskAccum"
                  v-model="mainForm.inclRiskAccum"
                  :error-messages="errors.collect('inclRiskAccum')"
                  data-vv-name="inclRiskAccum"
                  :data-vv-as="labels.inclRiskAccum"
                ></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ mainForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(mainForm.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ mainForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(mainForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
            <v-spacer class="mt-3"></v-spacer>
            <v-layout>
              <v-btn color="red" dark class=" mr-2" @click="doCancel" :loading="submitting">
                Cancel
                <v-icon right>mdi-cancel</v-icon>
              </v-btn>
              <v-btn v-if="!queryMode" color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
                Save Risk
                <v-icon right>mdi-content-save</v-icon>
              </v-btn>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate, removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { removeFormatNumber } from '@/utils/number.js'
import { formatPrice } from '@/utils/index'

export default {
  data() {
    return {
      submitting: false,
      newMode: false,
      reviewMode: false,
      queryMode: false,
      defBusCls: [],
      defTariff: [],
      defStdRiskTxtRef: [],
      defClse: [],
      labels: {
        riskNo: 'Risk No.',
        defTariff: 'Default Tariff',
        defBusCls: 'Default Business Class',
        defStdRiskTxtRef: 'Default Standard Risk Text',
        perMaxItemNo: 'Maximum No. of Item(s)',
        perMaxBeneNo: 'Maximum No. of Benefit(s)',
        defClse1: 'Default Risk Clause 1',
        defClse2: 'Default Risk Clause 2',
        defClse3: 'Default Risk Clause 3',
        defClse4: 'Default Risk Clause 4',
        defClse5: 'Default Risk Clause 5',
        allowClmBefCvr: 'Allow Claim Before Cover',
        inclRiskAccum: 'Include in Risk Accumulation',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      mainForm: {
        scheme: undefined,
        planNo: undefined,
        riskNo: 0,
        defTariff: undefined,
        defBusCls: undefined,
        defStdRiskTxtRef: undefined,
        perMaxItemNo: 1,
        perMaxBeneNo: 1,
        defClse1: undefined,
        defClse2: undefined,
        defClse3: undefined,
        defClse4: undefined,
        defClse5: undefined,
        allowClmBefCvr: false,
        inclRiskAccum: false,
        createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: new Date(),
        modifiedBy: null,
        modifiedDate: null
      },
      loading: true
    }
  },
  methods: {
    async doInit() {
      this.mainForm.scheme = this.pkgRiskId.scheme
      this.mainForm.planNo = this.pkgRiskId.planNo
      await this.$store.dispatch('packagePlanInit')
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.doGetBusCls()
      this.doGetTariff()
      this.doGetStdTxtRef()
      this.doGetClause()
      if (this.pkgRiskId.tranMode === 'reviewMode') {
        this.fetchData(true)
      }
    },
    async fetchData() {
      const apiURI = this.menu.getPkgRisk
      if (apiURI) {
        try {
          const expand = {
            scheme: this.pkgRiskId.scheme,
            planNo: this.pkgRiskId.planNo,
            riskNo: this.pkgRiskId.riskNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.mainForm.riskNo = data.pkgRisk.riskNo
            this.mainForm.defBusCls = data.pkgRisk.defBusCls
            this.mainForm.defTariff = data.pkgRisk.defTariff
            this.mainForm.defStdRiskTxtRef = data.pkgRisk.defStdRiskTxtRef
            this.mainForm.perMaxItemNo = data.pkgRisk.perMaxItemNo
            this.mainForm.perMaxBeneNo = data.pkgRisk.perMaxBeneNo
            this.mainForm.defClse1 = data.pkgRisk.defClse1
            this.mainForm.defClse2 = data.pkgRisk.defClse2
            this.mainForm.defClse3 = data.pkgRisk.defClse3
            this.mainForm.defClse4 = data.pkgRisk.defClse4
            this.mainForm.defClse5 = data.pkgRisk.defClse5
            this.mainForm.allowClmBefCvr = data.pkgRisk.allowClmBefCvr
            this.mainForm.inclRiskAccum = data.pkgRisk.inclRiskAccum
            this.mainForm.createdBy = data.createdBy
            this.mainForm.createdDate = data.createdDate
            this.mainForm.modifiedBy = data.modifiedBy
            this.mainForm.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doGetBusCls(event) {
      this.loading = true
      this.defBusCls = []
      const apiURI = this.menu.getBusClsParam
      if (apiURI) {
        this.$http
          .get(expandURI(apiURI))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.defBusCls.push({ value: list.value, label: list.label })
              })
            } else {
              this.loading = true
              this.defBusCls = []
            }
          })
          .catch((err) => {
            this.defBusCls = []
            const { data } = err.response
            if (data) {
              this.fieldMessage(data)
            }
          })
      }
    },
    doGetTariff(event) {
      this.loading = true
      this.defTariff = []
      const apiURI = this.menu.getTariffParam
      if (apiURI) {
        this.$http
          .get(expandURI(apiURI))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.defTariff.push({ value: list.value, label: list.label })
              })
            } else {
              this.loading = true
              this.defTariff = []
            }
          })
          .catch((err) => {
            this.defTariff = []
            const { data } = err.response
            if (data) {
              this.fieldMessage(data)
            }
          })
      }
    },
    doGetStdTxtRef(event) {
      this.loading = true
      this.defStdRiskTxtRef = []
      const apiURI = this.menu.getStdRiskTxtRef
      if (apiURI) {
        this.$http
          .get(expandURI(apiURI))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.defStdRiskTxtRef.push({ value: list.value, label: list.label })
              })
            } else {
              this.loading = true
              this.defStdRiskTxtRef = []
            }
          })
          .catch((err) => {
            this.defStdRiskTxtRef = []
            const { data } = err.response
            if (data) {
              this.fieldMessage(data)
            }
          })
      }
    },
    doGetClause(event) {
      this.loading = true
      this.defClse = []
      const apiURI = this.menu.getDefClse
      if (apiURI) {
        this.$http
          .get(expandURI(apiURI))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.defClse.push({ value: list.value, label: list.label })
              })
            } else {
              this.loading = true
              this.defClse = []
            }
          })
          .catch((err) => {
            this.defClse = []
            const { data } = err.response
            if (data) {
              this.fieldMessage(data)
            }
          })
      }
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createPkgRisk
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.mainForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'pkgRiskList' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updatePkgRisk
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.mainForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'pkgRiskList' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'pkgRiskList' })
    },
    toPkgItem() {
      this.$router.push({ name: 'pkgRiskItemList', params: { incomingRiskNo: this.incomingRiskNo } })
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    },
    formatDisplayDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    setValue() {
      this.$refs.childDiscPct.$el.cleave.setRawValue(this.mainForm.childDiscPct)
      this.mainForm.childDiscPct = formatPrice(this.$refs.childDiscPct.$el.cleave.getRawValue())
    }
  },
  created() {
    if (this.pkgRiskId.tranMode === 'newMode') {
      this.newMode = true
      this.reviewMode = false
    } else {
      this.newMode = false
      this.reviewMode = true
    }

    this.$validator.extend('valExpiry', {
      getMessage(field, args) {
        return 'Expiry Date must be equal or greater than Effective Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var expDate = args[0]
        if (expDate) {
          return !isAfter(removeTime(expDate), removeTime(value))
        }
      }
    })
    const mustGreaterThenZero = {
      getMessage: (field, args) => {
        return field + ' cannot be 0'
      },
      validate: (value, args) => {
        return removeFormatNumber(value) >= 0.000001
      }
    }

    this.$validator.extend('mustGreaterThenZero', mustGreaterThenZero)
  },
  computed: {
    menu() {
      return this.$store.state.pkgParam.pkgPlan.menu
    },
    busClsMenu() {
      return this.$store.state.busClsParam.menu
    },
    pkgPlanId() {
      return this.$store.state.pkgParam.pkgPlan.pkgPlanId
    },
    pkgRiskId() {
      return this.$store.state.pkgParam.pkgRisk.pkgRiskId
    },
    filterDefBusClsList() {
      return this.defBusCls.filter((list) => {
        return list.value === this.mainForm.defBusCls
      })
    },
    filterDefTariffList() {
      return this.defTariff.filter((list) => {
        return list.value === this.mainForm.defTariff
      })
    }
  },
  mounted() {
    this.doInit()
  },
  props: ['tranMode', 'incomingRiskNo', 'incomingScheme', 'incomingPlanNo'],
  mixins: [MessageMixin, commonAjaxMixin]
}
</script>
